<template>
    <b-button 
      :variant="variant" 
      :class="buttonClass" 
      @click="handleClick" 
      :disabled="disabled || isLoading"
    >
      <span v-if="!isLoading">{{ label }}</span>
      <b-spinner v-else small></b-spinner>
    </b-button>
  </template>
  
  <script>
  export default {
    props: {
      label: {
        type: String,
        required: true
      },
      variant: {
        type: String,
        default: 'primary'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      action: {
        type: Function,
        required: true
      }
    },
    data() {
      return {
        isLoading: false
      };
    },
    computed: {
      buttonClass() {
        return 'action-button';
      }
    },
    methods: {
      async handleClick() {
        this.isLoading = true;
        try {
          await this.action();
        } catch (error) {
          console.error(error);
        } finally {
          this.isLoading = false;
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .action-button {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 100px;
  }
  </style>
  